// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

type AppInsightConfig = {
  appConnectionString: string;
};

export const getDefaultAppInsightsConnectionString = async (functionsAppToken: string): Promise<string> => {
  const appInsightsUrl = 'api/appInsights';
  const response = await fetch(appInsightsUrl, {
    headers: new Headers({
      Authorization: `Bearer ${functionsAppToken}`
    })
  });
  const config: AppInsightConfig = await response.json();

  return config.appConnectionString;
};

export const getBotServerAppInsightsConnectionString = async (functionsAppToken: string): Promise<string> => {
  const appInsightsUrl = 'api/botServerAppInsights';
  const response = await fetch(appInsightsUrl, {
    headers: new Headers({
      Authorization: `Bearer ${functionsAppToken}`
    })
  });
  if (!response.ok) {
    throw new Error('Failed to get bot server app insights connection string');
  }

  const config: AppInsightConfig = await response.json();

  return config.appConnectionString;
};
